<template>
  <b-container>
    <div class="col-md-6">
      <h1>Edição de dados de usuário</h1>
      <success-fade-alert ref="mfaAlert" :msg="alert.mfa" />
      <success-fade-alert ref="alert" :msg="alert.success" />
      <fade-alert-danger ref="danger" :msg="alert.error" />

      <b-row class="mb-3 ml-0">
        <router-link :to="'../list'">
          <b-button size="sm">{{ $t("geral.backtolist") }}</b-button>
        </router-link>
        <Audit table="usuario" :keyValue="id" />
        <b-button
          v-if="isAdmin"
          class="ml-2"
          :title="$t('user.resetMfaSecretKey')"
          v-b-tooltip.hover
          size="sm"
          @click="resetMfa"
        >
          {{ $t("user.resetMfa") }}
        </b-button>
      </b-row>

      <b-form @submit.prevent="processForm">
        <crud-data
          :form="form"
          :modelstate="modelstate"
          :readonly="true"
          class="mb-4"
        ></crud-data>
        <!-- {{form}} -->
        <!-- submit button -->
        <div class="field has-text-right">
          <b-button type="submit" :disabled="submitted">Salvar</b-button>
        </div>
      </b-form>
    </div>
  </b-container>
</template>

<script>
export default {
  name: "Create",
  components: {
    Audit: () => import("@/components_rms/audit/Audit.vue"),
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    CrudData: () => import("@/components_rms/System/User/CrudData.vue"),
  },
  props: {
    id: String,
    module: String,
  },
  data: function () {
    return {
      alert: {
        error: "",
        mfa: "Chave secreta MFA refefinida com sucesso",
        success: "Usuário editado com sucesso",
      },
      modelstate: {},
      submitted: false,
      form: {
        nomeAcesso: "",
        senhaAcesso: "",
        documentNumber: "",
        email: "",
        nomeApresentacao: "",
        celular: "",
        telefone: "",
        entregador: "",
        plataforma: "",
        administrador: "",
        criadorFormularios: false,
        userType: 0,
      },
    };
  },
  created: function () {
    this.loadData();
  },
  computed: {
    isAdmin() {
      return this.$store.getters.isAdministrator;
    },
  },
  methods: {
    async loadData() {
      this.$apiScheduler
        .get("/usuario/" + this.id)
        .then((response) => {
          this.form = response.data;
        })
        .catch((error) => {
          console.log(error);
          console.log(error.response.data.errors);
          if (error.response.status == 400) {
            this.modelstate = error.response.data.errors;
          }
        });
    },
    resetMfa() {
      this.$apiScheduler
        .get(`/mfa/disable/${this.id}`)
        .then((response) => {
          this.$refs.mfaAlert.show();
        })
        .catch((error) => {
          console.log(error);
          console.log(error.response.data.errors);
          if (error.response.status == 400) {
            this.modelstate = error.response.data.errors;
          }
        });
    },
    processForm() {
      this.modelstate = {};
      console.log(this.form);
      this.submitted = true;
      this.$apiScheduler
        .post("usuario/edit/" + this.id.toString(), this.form)
        .then((response) => {
          this.submitted = false;
          if (response.data.success == false) {
            this.alert.error = response.data.title;
            this.$refs.danger.show();
          } else {
            this.$refs.alert.show();
            this.form = response.data;
          }
        })
        .catch((error) => {
          this.submitted = false;
          console.log(error);
          console.log(error.response);
          // console.log(error.response.data);
          // console.log(error.response.data.errors);
          if (error.response.status == 400) {
            if (error.response.data) {
              console.log(error.response.data.errors);
            }
            this.alert.error = error.response.data;
            this.$refs.danger.show();
            this.modelstate = error.response.data.errors;
          }
          if (error.response.status == 500) {
            if (error.response.data) {
              console.log(error.response.data.errors);
              this.alert.error = error.response.data;
              this.$refs.danger.show();
            }
            this.modelstate = error.response.data.errors;
          } else {
            this.alert.error = error.response.data;
            this.$refs.danger.show();
          }
        });
    },
  },
};
</script>